import { ButtonHeading, CommonDateRange, CommonInput, CommonTextarea, CustomPagination, CustomSelect } from 'components'
import React, { useState } from 'react'
import './addPayRec.css'
import { FiFilter } from 'react-icons/fi';
import { IoWarningOutline } from "react-icons/io5";
import { FiInfo } from "react-icons/fi";

const AddPaymentReceipt = () => {

    const cities_new = [
        { label: 'New York', value: 'ny' },
        { label: 'Los Angeles', value: 'la' },
        { label: 'Chicago', value: 'ch' },
        { label: 'Houston', value: 'ho' },
        { label: 'Phoenix', value: 'ph' }
    ];

    const [data, setData] = useState([
        {
            date: "12/12/2026",
            dueDate: "12/12/2026",
            invoice: "INV123123",
            total: 5900,
            due: 5000,
        },
        {
            date: "12/12/2026",
            dueDate: "12/12/2026",
            invoice: "INV123123",
            total: 5900,
            due: 5000,
        },
        {
            date: "12/12/2026",
            dueDate: "12/12/2026",
            invoice: "INV123123",
            total: 5900,
            due: 5000,
        },
        {
            date: "12/12/2026",
            dueDate: "12/12/2026",
            invoice: "INV123123",
            total: 5900,
            due: 5000,
        },
    ]);

    const handleChange = (index, field, value) => {
        const updated = [...data];
        updated[index][field] = value;
        setData(updated);
    };


    return (
        <>
            <div className='__addPayRec_mainBx'>
                <ButtonHeading title="Add Payment Receipt"/>

                <div className='__addPayRec_frmBx'>
                    <div className='__addPayRec_allBxs'>
                        <div className='__addPayRec_inupBx'>
                            <div className='__addPayRec_dualFx'>
                                <CommonDateRange />
                            </div>

                            <div className='__addPayRec_dualFx'>
                                <CommonInput placeholder='Payment Vouher' label='Payment Vouher' />
                            </div>

                            <div className='__addPayRec_dualFx'>
                                <CustomSelect placeholder='Vendor Type' label='Vendor Type' options={cities_new} />
                            </div>

                            <div className='__addPayRec_dualFx'>
                                <CustomSelect placeholder='Rohit Logistics' label='Rohit Logistics' options={cities_new} />
                            </div>

                            <div className='__addPayRec_dualFx'>
                                <CustomSelect placeholder='Payment Mode' label='Payment Mode' options={cities_new} />
                            </div>

                            <div className='__addPayRec_dualFx'>
                                <CustomSelect placeholder='Deposited To' label='Deposited To' options={cities_new} />
                            </div>

                            <div className='__addPayRec_dualFx'>
                                <CommonInput placeholder='Reference' label='Reference' />
                            </div>

                            <div className='__addPayRec_dualFx'>
                                <CommonInput placeholder='Payment Amount' label='Payment Amount' />
                            </div>
                        </div>

                        <div className='__txDeductDe'>
                            <p>Tax Deducted?</p>

                            <div className='__txDeductFlxs'>
                                {[
                                    { label: "No, Tax Deducted", value: 1 },
                                    { label: "Yes, TDS (Income Tax)", value: 2 },
                                ].map((i) => (
                                    <div className="_dualCheckr_bx" key={i?.value}>
                                        <input
                                            className="form-check-input"
                                            id={i?.label}
                                            type="radio"
                                            name="cash_credit_or_debit"
                                            value={i.value}
                                        // checked={i.value == form.cash_credit_or_debit}
                                        // onChange={({ target: { name, value } }) =>
                                        //     handleOnChange(name, Number(value))
                                        // }
                                        />
                                        <label htmlFor={i?.label} className="form-check-label">
                                            {i?.label}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className='__unpaidInvBx'>
                            <div className='__unpaidHead'><p>Unpaid Invoices</p></div>

                            <div className='__unpaid_searchFilter'>
                                <CommonInput placeholder='Search Invoices' label='Search Invoices' />
                                <button className='__unpaid_filterBtn'><FiFilter /> <span>Filters</span></button>
                            </div>

                            <div className="__unPaid_tableWrapper">
                                <table className="__unPaid_customTable">
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Invoice Number</th>
                                            <th>Total Amount</th>
                                            <th>Amount Due</th>
                                            <th>TDS</th>
                                            <th>Payment</th>
                                            <th></th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {data.map((item, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <div>{item.date}</div>
                                                    <small>Due Date: {item.dueDate}</small>
                                                </td>

                                                <td>{item.invoice}</td>

                                                <td>₹ {item.total.toLocaleString()}</td>

                                                <td>₹ {item.due.toLocaleString()}</td>

                                                <td>
                                                    <CommonInput
                                                        placeholder="Enter Amount"
                                                        className="tableInput"
                                                        onChange={(e) =>
                                                            handleChange(index, "tds", e.target.value)
                                                        }
                                                    />
                                                </td>

                                                <td>
                                                    <CommonInput
                                                        type="text"
                                                        placeholder="Enter Amount"
                                                        className="tableInput"
                                                        onChange={(e) =>
                                                            handleChange(index, "payment", e.target.value)
                                                        }
                                                    />
                                                </td>

                                                <td>
                                                    <span className="payLink">Pay in Full</span>
                                                </td>
                                            </tr>
                                        ))}

                                        <tr className="totalRow">
                                            <td colSpan="3"></td>
                                            <td>Total</td>
                                            <td>₹ 5,000.00</td>
                                            <td>₹ 5,000.00</td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div className='paginationFt_avt'>
                                    <CustomPagination
                                        totalItems={2}
                                        itemsPerPage={12}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className='__clainDeductBx'>
                            <div className='__clainDeductHead'><p>Add Claims Deductions</p></div>

                            <div>
                                <div className="noClaimsWrapper">
                                    <h3>No Claims Selected</h3>
                                    <p>Click the button below to select Claims for payment</p>

                                    <button className="selectClaim_btn">
                                        + Select Claims (150 available)
                                    </button>
                                </div>
                                <div className='paginationFt_avt'>
                                    <CustomPagination
                                        totalItems={2}
                                        itemsPerPage={12}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className='__pr_paymentSummary_mainBx'>
                            <div className="__pr_paymentSummary">
                                <div className="__pr_rowItem">
                                    <span className='__pr_semibold'>Amount Received :</span>
                                    <span>₹ 0.00</span>
                                </div>

                                <div className="__pr_rowItem">
                                    <span className='__pr_semibold'>Net Amount :</span>
                                    <span className="__pr_bold">₹ 0.00</span>
                                </div>

                                <div className="__pr_rowItem">
                                    <span className='__pr_semibold'>Amount used for Payments :</span>
                                    <span>₹ 0.00</span>
                                </div>

                                <div className="__pr_rowItem __pr_danger">
                                    <span><IoWarningOutline /> Amount in Excess:</span>
                                    <span>₹ 378700.00</span>
                                </div>

                                <div className="__pr_infoBox">
                                    {/* <FiInfo /> Excess amount will be available for adjustment in future payments */}
                                    💡 Excess amount will be available for adjustment in future payments
                                </div>
                            </div>
                        </div>
                        <div className='__notesBx'>
                            <span>Notes (Internal use. Not Visible to Customer)</span>
                            <CommonTextarea />
                        </div>
                    </div>
                </div>

                <div className="bottomFix">
                    <button className='anime-btn  _addComm_btn _sameWid'>Save</button>
                    <button className='anime-btn  _cancel_btn _sameWid'>Cancel</button>
                </div>
            </div>
        </>
    )
}

export default AddPaymentReceipt